"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryTupleStorage = void 0;
const tv = __importStar(require("../helpers/sortedTupleValuePairs"));
class InMemoryTupleStorage {
    constructor(data) {
        this.data = data || [];
    }
    scan(args) {
        return tv.scan(this.data, args);
    }
    commit(writes) {
        // Indexers run inside the tx so we don't need to do that here.
        // And because of that, the order here should not matter.
        const { set, remove } = writes;
        for (const tuple of remove || []) {
            tv.remove(this.data, tuple);
        }
        for (const { key, value } of set || []) {
            tv.set(this.data, key, value);
        }
    }
    close() { }
}
exports.InMemoryTupleStorage = InMemoryTupleStorage;
//# sourceMappingURL=../../src/storage/InMemoryTupleStorage.js.map